import { REQUERT_LAYOUT_LAYOUT_FAILED, GET_DATA_LAYOUT_LAYOUT_SUCCEEDED,
    REQUERT_Notification_FAILED, GET_DATA_Notification_SUCCEEDED, GET_DATA_LOGOUT_SUCCEEDED
} from '../actions/actionTypes'
import {combineReducers} from 'redux'

const layoutReducer = (DataLayout = [], actions) => {
    switch (actions.type) {
        case GET_DATA_LAYOUT_LAYOUT_SUCCEEDED:
            if(Object.keys(actions.DataLayout).length > 0)
            {
                return {...DataLayout,DataLayout: actions.DataLayout};
            }
            else
            {
                return {...DataLayout,DataLayout: []};
            }
        case REQUERT_LAYOUT_LAYOUT_FAILED:
            return {...DataLayout,DataLayout: []};
        default:
            return DataLayout;
    }
}
const NotiReducer = (DataNoti = [], actions) => {
    switch (actions.type) {
        case GET_DATA_Notification_SUCCEEDED:
            if(Object.keys(actions.DataNoti).length > 0)
            {
                return {...DataNoti,DataNoti: actions.DataNoti};
            }
            else
            {
                return {...DataNoti,DataNoti: []};
            }
        case REQUERT_Notification_FAILED:
            return {...DataNoti,DataNoti: []};
        default:
            return DataNoti;
    }
}
const LogoutReducer = (isLogout = false, actions) =>{
    switch (actions.type) {
        case GET_DATA_LOGOUT_SUCCEEDED:
            return {...isLogout,isLogout: actions.data};
        default:
            return {...isLogout,isLogout: false};
    }
}

const layoutALLReducer = combineReducers({
    layoutReducer,NotiReducer, LogoutReducer
})
export default layoutALLReducer;